module.exports = __webpack_public_path__ + "static/media/ncb shot 02.b769c792.webp";